import React, { useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import clsx from 'clsx'

import Button, { AppButtonTypes } from '../ButtonBase/Button'
import { AppLinks } from 'enviroment/AppLinks'
import applicationService from 'service/ApplicaionService/ApplicationService'
import { IConfirmCancelApplicationModalProps } from './ButtonCancelApplicationProps'
import useTextContents from 'common/hooks/useTextContents'
import { AppState } from 'store'

import './ButtonCancelApplicationStyles.scss'

/**
 * Komponent okienka modalnego potwierdzającego anulowanie wniosku
*/
const ConfirmCancelApplicationModal = (props: IConfirmCancelApplicationModalProps): JSX.Element => {
   const navigate = useNavigate()
   const { isOpen, setOpen, buttonTextContents } = props

   const handleOnConfirmation = async() => {
      await applicationService.cancelApplication()
      
      navigate(AppLinks.cancel)
   }

   const handleOnReject = () => {
      setOpen(false)
   }


   return (
      <Dialog open={isOpen} classes={{ paper: 'confirm-cancel-application-modal-wrapper-outer' }}>
         <DialogContent classes={{ root: 'confirm-cancel-application-modal-content-wrapper' }}>
           <p dangerouslySetInnerHTML={{__html: buttonTextContents('modals.cancelApplicationModal.mainContent')}}></p>
         </DialogContent>
         <DialogActions classes={{ root: 'confirm-cancel-application-modal-buttons-wrapper' }}>
            <Button uiButtonType={AppButtonTypes.SECONDARY} buttonContent={buttonTextContents('modals.cancelApplicationModal.buttonAgree')} className='confirm-cancel-application-modal-button' onClick={handleOnConfirmation} />
            <Button uiButtonType={AppButtonTypes.PRIMARY} buttonContent={buttonTextContents('modals.cancelApplicationModal.buttonDisagree')} className='confirm-cancel-application-modal-button' onClick={handleOnReject} />
         </DialogActions>
      </Dialog>
   )
}


/**
 * Komponent okienka modalnego potwierdzającego anulowanie wniosku
*/
const ChooseAnotherVerificationMethodOnCancelModal = (props: IConfirmCancelApplicationModalProps): JSX.Element => {
   const navigate = useNavigate()
   const { isOpen, setOpen, buttonTextContents } = props

   const handleOnCancelApplication = async() => {
      await applicationService.cancelApplication()
      setOpen(false)
      
      navigate(AppLinks.cancel)
   }

   const handleOnChooseAnotherMethod = () => {
      setOpen(false)
      navigate(AppLinks.chooseVerificationMethod)
   }


   return (
      <Dialog onClose={() => setOpen(false)} open={isOpen} classes={{ paper: 'choose-another-verification-method-modal-wrapper-outer' }} >
         <DialogTitle classes={{ root: 'confirm-cancel-application-modal-header'}}>{buttonTextContents('modals.chooseAnotherVerificationMethod.modalTitle')}</DialogTitle>
         <DialogContent classes={{ root: 'confirm-cancel-application-modal-content-wrapper choose-another-verification-method-modal-content-wrapper' }}>
           <p dangerouslySetInnerHTML={{__html: buttonTextContents('modals.chooseAnotherVerificationMethod.modalContent')}}></p>
         </DialogContent>
         <DialogActions id='choose-another-verification-method-modal-buttons-wrapper' classes={{ root: 'confirm-cancel-application-modal-buttons-wrapper' }}>
            <Button 
               uiButtonType={AppButtonTypes.PRIMARY} 
               buttonContent={buttonTextContents('buttons.chooseAnotherVerificationMethod')} 
               className='confirm-cancel-application-modal-button choose-another-verification-method-confirm-cancel-variant'
               onClick={handleOnChooseAnotherMethod}               
            />
            <Button 
               uiButtonType={AppButtonTypes.OUTLINED} 
               buttonContent={buttonTextContents('buttons.cancelApplication')} 
               className='confirm-cancel-application-modal-button choose-another-verification-method-confirm-cancel-variant'
               onClick={handleOnCancelApplication}
            />
         </DialogActions>
      </Dialog>
   )
}

/**
 * Komponent przycisku "anuluj wniosek" z okienkiem modalnym potwierdzającym anulowanie
*/
const ButtonCancelApplication = ({ className }: { className?: string }): JSX.Element => {
   const buttonTextContents = useTextContents()
   const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState<boolean>(false)
   const isAdditionalVerificationMethodsAvailable = useSelector((state: AppState) => state.applicationState.isAdditionalVerificationMethodsAvailable)

   return (
      <>
         {
            (isAdditionalVerificationMethodsAvailable && window.location.pathname === AppLinks.bmverify) ? 
            <ChooseAnotherVerificationMethodOnCancelModal isOpen={isConfirmationModalOpen} setOpen={setIsConfirmationModalOpen} buttonTextContents={buttonTextContents} /> :
            <ConfirmCancelApplicationModal isOpen={isConfirmationModalOpen} setOpen={setIsConfirmationModalOpen} buttonTextContents={buttonTextContents} />
         }
         <Button
            uiButtonType={AppButtonTypes.OUTLINED}
            buttonContent={buttonTextContents('buttons.cancelApplication')}
            className={clsx('page-application-cancel-button', className !== undefined && className)}
            onClick={() => setIsConfirmationModalOpen(true)}
         />
      </>
   )
}

export default ButtonCancelApplication
